@use '../../../../../styles/scss/vcom/mixins/breakpoints';

:host {
  display: block;
}

.vs-marquee-container {
  img {
    pointer-events: none;
  }
  .slides-wrapper-marquee,
  .slides-wrapper-submarquee {
    position: relative;
    ul {
      // START GENAI@GHCOPILOT
      list-style: none;
      margin: 0;
      padding: 0;
      // END GENAI@GHCOPILOT
    }
  }

  .slide {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 1s;
    z-index: 0;
  }

  .slide.active {
    opacity: 1;
    z-index: 1;
  }
  .slides-wrapper-quote {
    position: relative;
    margin-bottom: 20px;
    overflow: hidden; /* Prevent content from spilling out */
    transition: height 0.3s ease; /* Smooth height transition */

    ul {
      position: relative;
      margin: 0;
      padding: 0;
      list-style: none;
      width: 100%;
    }

    .slide {
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
      opacity: 0;
      z-index: 1;
      transition: opacity 0.5s ease;

      &.active {
        opacity: 1;
        z-index: 2;
        position: relative;
      }
    }
  }

  // Special styling for quote carousel indicators
  .slides-wrapper-quote + vs-slide-indicator {
    position: relative;
    z-index: 2;
    margin-top: 20px; // Add space between carousel and indicators
    display: block;
  }

  // Position the slide indicator correctly for quotes
  vs-slide-indicator {
    position: relative !important;
    top: auto !important;
    bottom: auto !important;
    margin-top: 20px !important;
    display: block !important;
    clear: both !important;
  }

  // Force the quote wrapper to have proper spacing
  .slides-wrapper-quote {
    margin-bottom: 20px !important;
  }

  // Fix for IE and older browsers
  .slides-wrapper-quote ~ vs-slide-indicator {
    margin-top: 20px !important;
  }

  /* Add fixed spacing below the quote container */
  :has(.slides-wrapper-quote) vs-slide-indicator {
    margin-top: 20px;
    position: relative;
    display: block;
  }
}
